import { createMuiTheme } from "@material-ui/core/styles";
const customStyle = createMuiTheme({
  overrides: {
   
    MuiListItem: {
      root: {
        fontSize: "0.813rem",
        paddingTop: 0,
        paddingBottom: 0,
      },
    },  
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      root: {
        backgroundColor: "#3d5a79",//#233298",
        borderRadius: " 0.75rem",
        border: 0,
        color: "white",
        // height: 38,
        textTransform: "none",
        fontWeight: "lighter",
        fontSize: "0.813rem",
        textAlign: "center",
      },
      text: {
        // backgroundColor: "#2978ca",
        color: "white",
        fontWeight: "lighter",
        fontSize: "0.813rem",
        textAlign: "center",
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: "#fff",
        textColor: "#3d5a79",
      },
      indicator: {
        // color: "primary",
        backgroundColor:"#3d5a79"
      },
      // label:{
      //   textTransform:"none",
      //   fontWeight:"bold"
      // }
    },
    MuiTab: {
      wrapper: {
        color: "#3d5a79",
        textTransform: "none",
        fontWeight: "bolder",
        fontSize:"0.814rem"

      },
    },
    MuiDialogActions: {
      root: {
        borderRadius: " 0.5rem",
        textTransform: "none",
      },
    },
    MuiTableCell: {
      head: {
        fontSize: "0.875rem",
        textTransform: "capitalize",
        fontWeight: "bold",
        color: "#fff",
      },
      body: {
        fontSize: "0.813rem",
        color: "#000000",
        fontWeight: "bold",
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: "#3d5a79",
      },
    },
    MuiFab: {
      label: {
        fontSize: "0.875rem",
        textTransform: "none",
        color: "#fff",
      },
      sizeSmall: {
        height: "0.5em",
        width: "2.5em",
      },
      root: {
        primary: "#3d5a79",
      },
    },
  },
 
  palette: {
    primary: {
      light: "#3d5a79",
      main: "#3d5a79",
    },
    secondary: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 12,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

export { customStyle };
